import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Check, Gift, Piano, Guitar, Music, Drum, Mic, Sliders, BookOpen, Music2, Headphones, Ear, ListMusic, Calendar, Wrench } from 'lucide-react';
export function WhatsIncluded() {
  const tomos = [{
    name: 'Tomo 1 — Piano desde cero',
    value: '7.990',
    icon: Piano
  }, {
    name: 'Tomo 2 — Guitarra fácil',
    value: '7.990',
    icon: Guitar
  }, {
    name: 'Tomo 3 — Violín para principiantes',
    value: '6.990',
    icon: Music
  }, {
    name: 'Tomo 4 — Batería y ritmo',
    value: '6.990',
    icon: Drum
  }, {
    name: 'Tomo 5 — Canto y afinación',
    value: '5.990',
    icon: Mic
  }, {
    name: 'Tomo 6 — Producción musical casera',
    value: '5.990',
    icon: Sliders
  }];
  const bonos = [{
    name: 'Bono 1 — Biblioteca de Partituras PRO',
    value: '3.990',
    icon: BookOpen
  }, {
    name: 'Bono 2 — Pack de Acordes Universales',
    value: '2.990',
    icon: Music2
  }, {
    name: 'Bono 3 — Entrenamiento Auditivo',
    value: '2.490',
    icon: Headphones
  }, {
    name: 'Bono 4 — Tocar de Oído',
    value: '2.190',
    icon: Ear
  }, {
    name: 'Bono 5 — Pistas para Practicar',
    value: '1.990',
    icon: ListMusic
  }, {
    name: 'Bono 6 — Rutina Musical de 30 Días',
    value: '1.690',
    icon: Calendar
  }, {
    name: 'Bono 7 — Guía de Equipos Musicales',
    value: '1.490',
    icon: Wrench
  }];
  return <section className="py-20 bg-navy-light relative overflow-hidden" data-id="element-295">
      <div className="absolute top-20 right-0 w-96 h-96 bg-gold/8 rounded-full blur-3xl pointer-events-none" data-id="element-296"></div>
      <div className="absolute bottom-20 left-0 w-80 h-80 bg-magenta/10 rounded-full blur-3xl pointer-events-none" data-id="element-297"></div>
      <div className="absolute top-1/2 left-1/2 w-72 h-72 bg-cyan/8 rounded-full blur-3xl pointer-events-none" data-id="element-298"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-299">
        <FadeIn data-id="element-300">
          <h2 className="text-3xl md:text-4xl font-black text-center text-beige mb-3" data-id="element-301">
            ¿Qué incluye{' '}
            <span className="text-gold drop-shadow-glow-gold" data-id="element-302">
              MUSIC PRO KIT
            </span>
            ?
          </h2>
          <p className="text-center text-beige/60 mb-12 text-lg" data-id="element-303">
            6 tomos completos + 7 bonos exclusivos
          </p>
        </FadeIn>

        {/* TOMOS */}
        <FadeIn data-id="element-304">
          <div className="bg-navy border border-gold/20 rounded-3xl p-8 md:p-10 shadow-2xl mb-6" data-id="element-305">
            <div className="flex items-center gap-2 mb-2" data-id="element-306">
              <Check className="w-6 h-6 text-gold drop-shadow-glow-gold" data-id="element-307" />
              <h3 className="text-xl font-bold text-gold" data-id="element-308">
                6 Tomos del Método Completo
              </h3>
            </div>
            <p className="text-beige/60 text-sm mb-8 ml-8" data-id="element-309">
              <span className="line-through" data-id="element-310">Total AR$ 34.990</span>
              <span className="mx-2" data-id="element-311">→</span>
              <span className="text-lime font-bold drop-shadow-glow-lime" data-id="element-312">
                Solo por hoy a AR$ 19.990
              </span>
            </p>

            <div className="space-y-3" data-id="element-313">
              {tomos.map((tomo, index) => {
              const Icon = tomo.icon;
              return <FadeIn key={index} delay={index * 0.06} direction="up" data-id="element-314">
                    <div className="flex items-center justify-between gap-4 bg-gold/5 p-4 rounded-xl border border-gold/25" data-id="element-315">
                      <div className="flex items-center gap-3" data-id="element-316">
                        <div className="w-9 h-9 rounded-full bg-gold flex items-center justify-center flex-shrink-0" data-id="element-317">
                          <Icon className="w-5 h-5 text-navy" strokeWidth={2.5} data-id="element-318" />
                        </div>
                        <span className="text-base md:text-lg font-medium text-beige" data-id="element-319">
                          {tomo.name}
                        </span>
                      </div>
                      <span className="text-sm text-beige/40 line-through flex-shrink-0" data-id="element-320">
                        AR$ {tomo.value}
                      </span>
                    </div>
                  </FadeIn>;
            })}
            </div>
          </div>
        </FadeIn>

        {/* BONOS */}
        <FadeIn data-id="element-321">
          <div className="bg-lime/5 border-2 border-lime/40 rounded-3xl p-8 md:p-10 shadow-xl mb-6" data-id="element-322">
            <div className="flex items-center gap-2 mb-6" data-id="element-323">
              <Gift className="w-6 h-6 text-lime drop-shadow-glow-lime" data-id="element-324" />
              <h3 className="text-xl font-bold text-lime drop-shadow-glow-lime" data-id="element-325">
                7 Bonos Exclusivos
              </h3>
            </div>

            <div className="space-y-3 mb-6" data-id="element-326">
              {bonos.map((bono, index) => {
              const Icon = bono.icon;
              return <FadeIn key={index} delay={index * 0.05} direction="up" data-id="element-327">
                    <div className="flex items-center justify-between gap-4 bg-navy-lighter p-4 rounded-xl border border-lime/20" data-id="element-328">
                      <div className="flex items-center gap-3" data-id="element-329">
                        <div className="w-9 h-9 rounded-full bg-lime flex items-center justify-center flex-shrink-0" data-id="element-330">
                          <Icon className="w-5 h-5 text-navy" strokeWidth={2.5} data-id="element-331" />
                        </div>
                        <span className="text-base md:text-lg font-medium text-beige" data-id="element-332">
                          {bono.name}
                        </span>
                      </div>
                      <span className="text-sm text-beige/40 line-through flex-shrink-0" data-id="element-333">
                        AR$ {bono.value}
                      </span>
                    </div>
                  </FadeIn>;
            })}
            </div>

            <div className="bg-lime/15 border border-lime/50 rounded-xl p-3 text-center" data-id="element-334">
              <span className="text-lime font-black text-lg drop-shadow-glow-lime" data-id="element-335">
                🎁 GRATIS POR HOY
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}